import React from 'react';
import { Skeleton, Typography } from 'fronton-react';
import { formatNumber } from 'common/utils/format-number';
import { BonusLogo } from '@fronton/icons-react/logos';
import { PointsWrapper } from './styles';

interface IPoints {
  loading: boolean;
  points: number | null;
}

export const QA_BONUS_LOGO = 'loyalty-points-logo';
export const QA_LOYALTY_POINTS = 'loyalty-points';
export const QA_LOYALTY_POINTS_SKELETON = 'loyalty-points-skeleton';

export const Points: React.FC<IPoints> = ({ loading, points }) => {
  if (loading) {
    return (
      <PointsWrapper>
        <Typography variant="s" size="overline" data-qa={QA_LOYALTY_POINTS_SKELETON}>
          <Skeleton width="24px" height="12px" variant="control" roundingSize="xl" />
        </Typography>
        <Skeleton width="20px" height="20px" variant="control" roundingSize="circle" />
      </PointsWrapper>
    );
  }

  if (points !== null) {
    return (
      <PointsWrapper>
        <Typography
          variant="s"
          size="overline"
          color={points < 0 ? 'attention-primary' : 'text-primary'}
          data-qa={QA_LOYALTY_POINTS}
        >
          {formatNumber(points)}
        </Typography>
        <BonusLogo data-qa={QA_BONUS_LOGO} width={20} height={20} />
      </PointsWrapper>
    );
  }

  return <></>;
};
